import { useContext } from "react";

import { RanaFormContext } from "../rana-form";
import { FormValuesExtend } from "../use-rana-form";

const isString = (x: FormValuesExtend[keyof FormValuesExtend]) =>
  typeof x === "string" || x instanceof String;

export const useRanaFormIsValid = () => {
  const { required, values } = useContext(RanaFormContext);
  if (required.length === 0) return true;
  return required.every((field) =>
    isString(values[field]) ? values[field].trim() !== "" : values[field] != null
  );
};
